import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { IwgSelectService } from '../../../shared/services/iwgselect.service';
import { IwgSelect } from '../../../shared/Models/iwgselect.model';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

const noop = () => {
};

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AllocationSelectComponent),
  multi: true
};

@Component({
  selector: 'app-allocation-select',
  templateUrl: './allocation-select.component.html',
  styleUrls: ['./allocation-select.component.scss'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})

export class AllocationSelectComponent implements ControlValueAccessor{
  @Input('preselected-item-id') preselectedItemId: any;
  @Input('refresh-on-preselect') refreshOnPreselect: boolean;
  @Input('disabled') disabled = false;
  @Input('assignmentid') assignmentid: any;
  @Input() isRequired = false;

  allocationid: any;
  @Output() selectionChange = new EventEmitter();

  isLoading = false;
  items: IwgSelect[] = [];
  location: IwgSelect[] = [];
  loadPromise: any;
  event: any;
  isOpen = false;
  constructor(private iwgselectservice: IwgSelectService) {

  }
  private innerValue: any = '';
  get value(): any { return this.innerValue; }
  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
    }
  }
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;
  writeValue(value: any) {if (value !== this.innerValue) { this.innerValue = value;}}
  registerOnChange(fn: any) {this.onChangeCallback = fn;}
  registerOnTouched(fn: any) {this.onTouchedCallback = fn;}

  ngOnInit(): void {
  }

  onOpen(event){    
    this.isOpen = event;
    if(!event || (this.items && this.items.length > 0)){
      return;
    } 
    this.isLoading = true;
    this.get();
  }
  
  get(setId=false){
    this.iwgselectservice.getAllocation(this.assignmentid).subscribe(
      result=>{
        this.isLoading = false;
        if (result.apiCallStatus && result.data.Data) {
            this.items = result.data.Data;
        }
      },
      error => {
          this.isLoading = false;
          console.log(error);
      });
  }
  onValChange($event){
    this.selectionChange.emit($event.value);
  }

}
